/* iceberg-ui */
import { Box } from '@auviknetworks/iceberg-ui';

/*  React  */
import React from 'react';

/*  Components  */
import { AccountsOverview } from './internal/AccountsOverview';
import { SummaryCard } from './internal/AccountsSummaryCard';

export const AccountsInventoryReport = ({ reportSetup, reportData }) => {
    const {
        accountsInventoryAccountsInventoryAccountOverview,
        accountsInventoryAccountsInventoryAccountSummary
    } = reportData || {};

    return (
        <Box data-testid="accountsReportMainRender" width="100%">
            {reportSetup.reportSelections?.includes(
                'accountsInventoryAccountsInventoryAccountSummary'
            ) && (
                <Box id="accountsInventoryAccountsInventoryAccountSummary">
                    <SummaryCard
                        {...accountsInventoryAccountsInventoryAccountSummary}
                    />
                </Box>
            )}
            {reportSetup.reportSelections?.includes(
                'accountsInventoryAccountsInventoryAccountOverview'
            ) && (
                <Box id="accountsInventoryAccountsInventoryAccountOverview">
                    <AccountsOverview
                        accounts={
                            accountsInventoryAccountsInventoryAccountOverview
                        }
                    />
                </Box>
            )}
        </Box>
    );
};
